import { ActionContext } from "vuex";

const state = {
  error: null
};

const getters = {
  isError: (state: any) => state.error !== null
};

const actions = {
  clearError(context: ActionContext<any, any>) {
    context.commit("CLEAR_ERROR");
  },
  setError(context: ActionContext<any, any>, error_: String) {
    context.commit("ERROR", error_);
  }
};

const mutations = {
  ERROR(state: any, error_: any) {
    if (typeof error_ === "object" && error_ !== null) {
      if (error_.error && error_.error.message) {
        state.error = `${error_.msg} ${error_.error.message}`;
      } else if (error_.msg) {
        state.error = error_.msg;
      } else {
        state.error = "Error";
      }
    } else {
      state.error = error_;
    }
  },
  CLEAR_ERROR(state: any) {
    state.error = null;
  }
};

const error = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default error;
